module.exports = __webpack_public_path__ + "media/media/favicon/safari-pinned-tab-f2eb1de00e59ffe139999b0341fd72ec.svg";